import styled from 'styled-components';

export const TravelRoomsDropdownWrap = styled.div({
  '.absolute-dropdown': {
    width: '400px',
    display: 'flex',
    flexDirection: 'column',
  },
});
